// import mainTemplate from './views/main.tpl.html';
import listTemplate from './views/list.tpl.html';
import detailsTemplate from './views/details.tpl.html';
import editTemplate from './views/editor.tpl.html';

angular
    .module('festzelt-os.modules.bo.objects')
    .config([
        '$stateProvider',
        config
    ]);

function config($stateProvider) {
    $stateProvider
        .state('app.bo.objects', {
            abstract: true,
            url: 'objects',
            template: '<ui-view/>',
        })
        .state('app.bo.objects.index', {
            url: '/',
            sticky: true,
            data: {
                rights: 'bookable_objects::object_list',
            },
            templateUrl: listTemplate,
            controller: 'BoObjectsListController',
            controllerAs: 'vm'
        })
        .state('app.bo.objects.details', {
            url: '/{objectId}',
            data: {
                rights: 'bookable_objects::object_view',
            },
            params: {
                objectId: {
                    type: 'int',
                    dynamic: true,
                    inherit: true,
                    value: -1
                }
            },
            templateUrl: detailsTemplate,
            controller: 'BoObjectDetailsController',
            controllerAs: 'vm'
        })
        .state('app.bo.objects.edit', {
            url: '/{id}/edit',
            data: {
                rights: 'bookable_objects::object_edit',
            },
            templateUrl: editTemplate,
            controller: 'BoObjectEditController',
            controllerAs: 'vm'
        })
        .state('app.bo.objects.create', {
            url: '/create',
            data: {
                rights: 'bookable_objects::object_create',
            },
            templateUrl: editTemplate,
            controller: 'BoObjectCreateController',
            controllerAs: 'vm'
        });
}



// WEBPACK FOOTER //
// ./src/app/modules/bo/objects/routes.js